import { Box, Paper, Typography } from '@mui/material';
import { useFunds, useUsers } from '@lingaai/shared-hooks';

interface OverviewTabProps {
  tenant: any;
}

export function OverviewTab({ tenant }: OverviewTabProps) {
  const { data: funds } = useFunds(tenant.id);
  const { data: users } = useUsers(tenant.id);

  const adminUsers = users?.filter((u) => u.role === 'admin') || [];
  const portcoUsers = users?.filter((u) => u.role === 'portco') || [];

  const stats = [
    { label: 'Total Funds', value: funds?.length || 0 },
    { label: 'Admin Users', value: adminUsers.length },
    { label: 'Portfolio Company Users', value: portcoUsers.length },
    { label: 'Total Users', value: users?.length || 0 },
  ];

  return (
    <Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 3, mb: 3 }}>
        {stats.map((stat) => (
          <Paper key={stat.label} sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="h3" color="primary">
              {stat.value}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {stat.label}
            </Typography>
          </Paper>
        ))}
      </Box>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Tenant Information
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary">
            <strong>Workspace Slug:</strong> {tenant.workspace_slug}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            <strong>Workspace Email:</strong> {tenant.workspace_email}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            <strong>Created:</strong> {new Date(tenant.created_at).toLocaleDateString()}
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
}
